$exso_table $mol_section
	columns /
	columns_meta *
	item_key \
	items /
	items_map null
	reverse false
	Content $mol_list sub /
		<= Total $mol_row sub <= total /
		^ item_rows / <= Item*0 $mol_row
			sub <= item_columns* / <= Column* $mol_labeler
				title <= column_title* \
				Content <= Column_contents* $mol_row sub <= column_contents* /
					<= Column_content* $mol_view
						attr * title <= column_content_hint* \hint
						sub / <= column_content* @ \Итого
